<div class="representante-filter">
    <div class="representante-filter-quick">  
        <div class="representante-filter-quick-block representante-filter-quick-block-multiselect">
            <!-- Situações -->
            <div class="representante-filter-quick-block-multiselect-item" *ngIf="!hideSituacoes()">
                <sgt-representante-situacao-multiselect
                    [(situacoes)]="filter.situacoes"
                    (situacoesChange)="onChangeSituacoes()"
                    defaultTitle="Situações"
                    [showSomenteComClientes]="true"
                    [(somenteComClientes)]="filter.somenteComClientes"
                    [disabled]="!isFilterInitialized">
                </sgt-representante-situacao-multiselect>
            </div>

            <!-- Modalidades Comerciais -->
            <div class="representante-filter-quick-block-multiselect-item">
                <sgt-representante-modalidade-comercial-multiselect
                    [(modalidades)]="filter.modalidadesComerciais"
                    (modalidadesChange)="onChangeModalidadesComerciais()"
                    [disabled]="!isFilterInitialized">
                </sgt-representante-modalidade-comercial-multiselect>
            </div>            

            <!-- Classificações de Clientes -->
            <div class="representante-filter-quick-block-multiselect-item">
                <sgt-classificacao-tipo-multiselect
                    [(idsClassificacoes)]="filter.idsClassificacoesClientes"
                    (idsClassificacoesChange)="onChangeClassificacoesClientes()"
                    [(nullOption)]="filter.classificacaoNull"
                    [showNullOption]="true"
                    [tipoClassificacaoCadastroCliente]="true"
                    defaultTitle="Segmentos de Clientes"
                    [disabled]="!isFilterInitialized">
                </sgt-classificacao-tipo-multiselect>                
            </div>            

            <!-- Atendentes -->
            <div class="representante-filter-quick-block-multiselect-item">
                <sgt-usuario-multi-select
                    [(ngModel)]="filter.idsAtendentes"
                    name="atendentes"
                    [perfil]="EnumUsuarioPerfil.ATENDENTE"
                    [situacao]="EnumSituacao.ATIVO"
                    [settings]="{
                        placeholder: 'Atendentes',
                        singular: 'Atendente',
                        plural: 'Atendentes',
                        searchEmptyResultMessage: 'Nenhum atendente encontrado',
                        showFooter: true
                    }"
                    (search)="onChangeAtendentes()"
                    [disabled]="!isFilterInitialized">
                </sgt-usuario-multi-select>
            </div>

            <!-- Gerentes -->
            <div class="representante-filter-quick-block-multiselect-item">
                <sgt-usuario-multi-select
                    [(ngModel)]="filter.idsGerentes"
                    name="gerentes"
                    [perfil]="EnumUsuarioPerfil.GERENTE"
                    [situacao]="EnumSituacao.ATIVO"
                    [settings]="{
                        placeholder: 'Gerentes',
                        singular: 'Gerente',
                        plural: 'Gerentes',
                        searchEmptyResultMessage: 'Nenhum gerente encontrado',
                        showFooter: true
                    }"
                    (search)="onChangeGerentes()"
                    [disabled]="!isFilterInitialized">
                </sgt-usuario-multi-select>
            </div>
        </div>

        <div class="representante-filter-quick-block representante-filter-quick-block-filter-psq">
            <input type="text" class="form-control" [(ngModel)]="filter.filterPsq"  #filterPsq="ngModel" name="filterPsq" id="filterPsq" placeholder="Digite para pesquisar...">
        </div>        

        <div class="representante-filter-quick-block representante-filter-quick-block-options">
            <div class="representante-filter-quick-block-options-btns">
                <div class="btn-group">
                    <button type="button" class="btn btn-light" (click)="refresh()" title="Atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-sync"></i>
                    </button>
                    <button type="button" class="btn btn-light" (click)="clear()" title="Limpar filtro e atualizar"
                        [disabled]="!isFilterInitialized">
                        <i class="fas fa-eraser" aria-hidden="true"></i>
                    </button>
    
                    <button type="button" class="btn" [class.btn-light]="!filter.isFilterDirty" [class.btn-danger]="filter.isFilterDirty"
                        (click)="toggleCollapse()" title="Filtro avançado"
                        [disabled]="!isFilterInitialized">
                        <ng-template [ngIf]="isFilterInitialized">
                            <i class="fas fa-filter" aria-hidden="true"></i>
                            <i [class]="collapseIcon" aria-hidden="true"></i>
                        </ng-template>
                        <ng-template [ngIf]="isFilterInitializing">
                            <i class='fas fa-spinner fa-pulse'></i>
                        </ng-template>
                    </button>
                </div>  
            </div>
        </div>
    </div>

    
    <div class="representante-filter-collapse" #filterCollapse>
        <div class="row">
            <div class="form-group col-12 col-md-3">
                <label for="dataCadastroInicial" class="col-form-label">Cadastro Inicial</label>
                <sgt-datepicker [(ngModel)]="filter.dataCadastroInicial" name="dataCadastroInicial" id="dataCadastroInicial"
                    #dataCadastroInicial="ngModel" [ngControl]="dataCadastroInicial" (ngModelChange)="onChangeDataCadastro($event)">
                </sgt-datepicker>                        
            </div>
            <div class="form-group col-12 col-md-3">
                <label for="dataCadastroFinal" class="col-form-label">Cadastro Final</label>
                <sgt-datepicker [(ngModel)]="filter.dataCadastroFinal" name="dataCadastroFinal" id="dataCadastroFinal"
                    #dataCadastroFinal="ngModel" [ngControl]="dataCadastroFinal" (ngModelChange)="onChangeDataCadastro($event)">
                </sgt-datepicker>                        
            </div>    
        </div>
        
        <div class="row">
            <div class="form-group col-12 col-md-6">
                 <label for="filterEstado" class="col-form-label">Estado</label>
                 <sgt-estado-multiselect
                    [(idsEstados)]="filter.idsEstados"
                    (idsEstadosChange)="onChangeEstados()"
                    [disabled]="!isFilterInitialized">
                </sgt-estado-multiselect>                
            </div>
            <div class="form-group col-12 col-md-6">
                <label for="filterCidade" class="col-form-label">Cidade</label>
                <sgt-typeahead-cidade [(ngModel)]="filter.cidade" name="filterCidade" id="filterCidade"
                    #filterCidade="ngModel" [ngControl]="filterCidade" [dropup]="true"
                    (typeaheadChange)="onChangeCidade($event)">
                </sgt-typeahead-cidade>                    
            </div>
        </div>      
    </div>
</div>

